
import UserInfo from './UserInfo.vue'
import { PageInfo, Query } from '@/schema'
import { CourseCompletionItem } from '../types'
import { COURSE_COMPLETIONS_QUERY } from '../gql/queries'
import { ApolloQueryResult } from '@apollo/client'

export default {
    name: 'UserCourseCompletions',
    components: {
        UserInfo,
    },
    props: {
        course: {
            type: Object,
            required: true,
        },
        userId: {
            type: String,
            required: true,
        },
        isUpdating: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            isFetchingCourseCompletions: true,
            courseCompletions: [] as CourseCompletionItem[],
            pageInfo: null as Maybe<PageInfo>,
            infiniteId: Date.now(),
            completeDate: null as Maybe<string>,
            completeDateMenu: false,
        }
    },
    methods: {
        isoDate(value: Maybe<string>, format = 'DD.MM.YYYY') {
            if (!value) return null
            return this.formatDate(value, this.getDeviceTimeZone, format)
        },
        loadCourseCompletions($state: any) {
            if (!this.pageInfo || this.pageInfo.hasNextPage) {
                this.$apollo
                    .query({
                        query: COURSE_COMPLETIONS_QUERY,
                        variables: {
                            course: this.course.id,
                            projectId: this.currentProjectId,
                            after: this.pageInfo?.endCursor,
                            users: [this.userId],
                        },
                        fetchPolicy: 'network-only',
                    })
                    .then((result: ApolloQueryResult<Query>) => {
                        if (result.data) {
                            result.data.courseCompletions?.nodes?.forEach((item) => {
                                this.courseCompletions.push(item as CourseCompletionItem)
                            })
                            this.pageInfo = result.data.courseCompletions?.pageInfo || null
                        }
                        $state.loaded()
                    })
                    .catch(() => {
                        $state.complete()
                    })
            } else {
                $state.complete()
            }
        },
    },
}
